import { useState, type FC } from "react";
import { Checkbox, Label } from "flowbite-react";
import { useTranslation } from "react-i18next";
import { StyledTextInput, Dialog, Button } from "@components";
import { validateEmail } from "../../helpers/validationHelper";

export interface SendDeliveryLetterProp {
  show: boolean;
  isLoading: boolean;
  toggleModal: () => void;
  confirmButton: (email: string) => void;
}
interface DialogContentProps {
  toggleModal: () => void;
  confirmButton: (email: string) => void;
}
export const SendDeliveryLetter: FC<SendDeliveryLetterProp> = (props) => {
  return (
    <Dialog
      size="md"
      denseHeader
      show={props.show}
      toggleModal={props.toggleModal}
      hideButtons={true}
      dismissible
      content={
        <DialogContent
          toggleModal={props.toggleModal}
          confirmButton={props.confirmButton}
        />
      }
    />
  );
};

const DialogContent: FC<DialogContentProps> = (props) => {
  const { t } = useTranslation(["common", "orders", "stats"]);
  const [hasAcceptedTerms, setHasAcceptedTerms] = useState(false);
  const [validationFailed, setValidationFailed] = useState(false);
  const [email, setEmail] = useState<string>("");

  const validateAndSend = () => {
    if (!validateEmail(email)) {
      setValidationFailed(true);
    } else {
      setValidationFailed(false);
      props.confirmButton(email);
    }
  };
  return (
    <div className="flex flex-col items-start justify-between gap-4">
      <p className="text-xl font-medium text-gray-900">
        {t("orders:completed_orders.delivery_letter_title")}
      </p>
      <p className="text-md text-muted">
        {t("orders:completed_orders.delivery_letter_description")}
      </p>

      <div className="w-full">
        <Label
          className="dark:text-muted"
          htmlFor="reciever"
          value={t("orders:completed_orders.delivery_letter_reciever")}
        />
        <form className="w-full">
          <StyledTextInput
            id="reciever"
            placeholder={t(
              "orders:completed_orders.delivery_letter_reviecer_ph",
            )}
            type="text"
            onInputChanged={(e) => setEmail(e)}
            validation={{
              id: "weight",
              show: validationFailed,
              isInvalid: validationFailed,
              errorMessage: t("validation:email"),
            }}
          />
        </form>
      </div>

      <div className="flex items-center gap-2 py-4 px-4 bg-surface-muted rounded">
        <Checkbox
          id="terms"
          className="text-lgb-primary dark:text-lgb-primary-lighten"
          onChange={() => setHasAcceptedTerms(!hasAcceptedTerms)}
        />
        <Label htmlFor="terms" className="text-muted font-normal">
          {t("orders:completed_orders.delivery_letter_terms")}
        </Label>
      </div>

      <div className="flex gap-4">
        <Button color="gray" onClick={() => props.toggleModal()}>
          {t("common:close")}
        </Button>
        <Button
          onClick={validateAndSend}
          color="primary"
          disabled={!hasAcceptedTerms}
        >
          {t("common:send")}
        </Button>
      </div>
    </div>
  );
};
